import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import React, { useMemo, useCallback, memo, useEffect } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";

import MegaMenuItemPresenter from "presenters/MegaMenuItemPresenter";

import useStyles from "./useStyles";

const LinkList = memo(({ list, mainMenuLinks, onLinkActiveChange }) => {
  const classes = useStyles();
  const location = useLocation();
  const hasActiveLink = useMemo(() => {
    const currentPath = location.pathname;
    const matchingLink = list.find((link) => link.linkTo === currentPath);

    if (!matchingLink) return false;

    const conflictsWithMainMenu = mainMenuLinks.includes(matchingLink.linkTo);

    return !conflictsWithMainMenu;
  }, [list, location.pathname, mainMenuLinks]);

  const handleActiveChange = useCallback(
    (isActive) => {
      if (onLinkActiveChange) onLinkActiveChange(isActive);
    },
    [onLinkActiveChange],
  );

  useEffect(() => {
    handleActiveChange(hasActiveLink);
  }, [hasActiveLink, handleActiveChange]);

  const listItems = useMemo(
    () =>
      list.map((link) => (
        <ListItem className={classes.listItem} key={link.name} id={link.name}>
          <ListItemButton className={clsx(classes.listItem, classes.listButton)}>
            <Link className={classes.link} to={link.linkTo}>
              <ListItemText>{link.name}</ListItemText>
            </Link>
          </ListItemButton>
        </ListItem>
      )),
    [list, classes],
  );

  return <List className={classes.listContainer}>{listItems}</List>;
});

LinkList.propTypes = {
  list: PropTypes.arrayOf(MegaMenuItemPresenter.shape()),
  mainMenuLinks: PropTypes.arrayOf(PropTypes.string),
  onLinkActiveChange: PropTypes.func,
};

export default LinkList;
